import { render, staticRenderFns } from "./ContentLoaderReview.vue?vue&type=template&id=e7d6e704&"
import script from "./ContentLoaderReview.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports